import { Customer } from "../../types";

export function filterByName(customers: Customer[], filterVal: string): Customer[] {
    return customers.filter(c => c.name.toLowerCase().includes(filterVal.toLowerCase()));
}